module.exports = __webpack_public_path__ + "media/images/official/event_bg_2-d1ee615aa67a2c6d1efd61130cae6b6a.jpg";